module.exports = __webpack_public_path__ + "img/slot-animation.86f4e207.gif";